import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import History from '../../Components/History/History';
import ParentComponent from '../../Components/ParentComponent/ParentComponent';
import { useLocation } from 'react-router-dom';

const TravelHistory = () => {
    const location = useLocation();
    const { travelData } = location.state;

    const dropdownOptions = [
        { label: 'Last 7 Days', value: '7' },
        { label: 'Last 15 Days', value: '15' },
        { label: 'Last 30 Days', value: '30' }
    ];

    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };
    const formatDueDate = (date) => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };
    const handleDownloadCSV = () => {
        const csvData = [
            ['Purpose of Travel', 'From', 'To', 'Distance Driven (km)', 'Time Spent (mins)', 'Date'],
            ...travelData.map(item => [
                item.purpose,
                item.startLocation,
                item.destination,
                item.distance+' km',
                item.duration+' mins',
                formatDueDate(item.scheduledDate)
            ])
        ];

        const csvString = csvData.map(row => row.join(',')).join('\n');

        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', 'travel_history.csv');
        a.click();
    };

    return (
        <ParentComponent>

            <div className="flex justify-between items-center mb-6">
                <div className="mb-4 lg:mb-0">
                    <h1 className="text-2xl font-semibold text-gray-800">User Management</h1>
                    <nav className="text-gray-500 text-sm">
                        <a href="#" className="hover:underline">Dashboard</a>
                        <span className="mx-2">•</span>
                        <a href="#" className="text-gray-800 hover:underline">User Management</a>
                    </nav>
                </div>
            </div>
            <History viewall={false} need={true} heading={'Travel History'} travelData={travelData} handleDownloadCSV={handleDownloadCSV} dropdownOptions={dropdownOptions} selectedOption={selectedOption} handleOptionChange={handleOptionChange} />

        </ParentComponent>
    );
};

export default TravelHistory;
